export const MSG_TYPE = {
  TXT: 'TXT',
  IMG: 'IMG',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  CODE: 'CODE',
  PHONE: 'PHONE',
  CUSTOM: 'CUSTOM',
  CMD: 'CMD',
};

export const READ_STATUS = {
  ONLY_READ: 1, // 用户看到了消息
  READ_AND_PLAY: 11, // 用于看到了消息并且点击了播放按钮
};

export const MSG_CODE_TYPE = {
  RECALL: 'recall', // 撤回消息
  SESSION_INFO: 'session_info', // 会话心跳，实际上是告诉老师当前学生的在线状态
  VIEW_COMMUNICATE: 'view_communicate', // 辅导端老师发起语音连麦
  VIEW_COMMUNICATE_LOSE: 'view_communicate_lose', // 关闭语音连麦
};

export const NEW_MSG_TYPE = {
  APPEND_SELF: 'append_self', // 添加我自己发送的新消息
  APPEND_PEER: 'append_peer', // 添加接收到的新消息
  PREPEND: 'prepend', // 加载历史消息
};

// 语音连麦请求的通知弹窗
// 这是一个临时方案，等后续支持语音连麦后，需要删除
export const IM_AUDIO_COMMUNICATE_NOTIFICATION =
  'im_audio_communicate_notification';

export const IM_BUSINESS = 'online_class';
export const IM_APPID = 'im-business';
export const IM_CONFIG_APPID_DEV = 'live-service';
export const IM_CONFIG_APPID_PROD = 'live-service';
export const IM_CONFIG_APPKEY_DEV = 'p5tvi9dspe3n4';
export const IM_CONFIG_APPKEY_PROD = 'n19jmcy5na789';
